import axios from 'axios';
import { API } from '../../../lib/api/api';

// Deletes a users facebook page from our database
export const deleteFacebookPage = async (
	id: number,
	facebookPageId: string,
	facebookUserId: string
) => {
	try {
		return await axios.get(
			`${API}facebook/deletePage?id=${id}&facebookPageId=${facebookPageId}&facebookUserId=${facebookUserId}`
		);
	} catch (e) {
		return {
			error: e,
			status: 'error',
			statusText: 'There was a problem deleting your connected Facebook page.',
			data: e
		};
	}
};
